<li ngbDropdown class="nav-item dropdown-notification mr-25">
  <a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown"><i class="ficon" data-feather="bell"></i><span
      class="badge badge-pill badge-danger badge-up">{{actions?.length}}</span></a>
  <ul ngbDropdownMenu aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right">
    <!-- Notifications header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Aksiyonlar bildirimleri</h4>
        <div class="badge badge-pill badge-light-primary">
          {{actions?.length}}
        </div>
      </div>
    </li>
    <!--/ Notifications header -->

    <!-- Notifications content -->
    <li class="scrollable-container media-list" [perfectScrollbar] *ngFor="let item of actions">
      <a class="d-flex" href="javascript:void(0)" (click)="showActionDetail(item.id)">
        <div class="media d-flex align-items-start">
          <div class="media-left">
            <div class="avatar bg-light-success avatar">
              <span class="avatar-content">{{item.no}}</span>
            </div>
          </div>
          <div class="media-body">
            <p class="media-heading" [innerHTML]="item.title"></p>
            <small class="notification-text">{{item.startActionDate | date:'dd.MM.yyyy'}} - {{item.finishActionDate |
              date:'dd.MM.yyyy'}}</small>
          </div>
          <div class="badge badge-pill badge-primary">{{item.typeName}}</div>
        </div>
      </a>
    </li>
  </ul>
</li>